import { Fragment, h } from 'preact';
import { forwardRef } from 'preact/compat';
import { useContext } from 'preact/hooks';
import { VOID_FN } from '../../../../../utils';
import { IconContext } from '../../../../common/components/svg/icons/icon-context';
import { useNewStore, useStyles } from '../../../../common/hooks';
import { LABELS_FILL_COLOR, SECONDARY_TEXT_COLOR } from '../../../theme/colors';
import { ROW_ITEM_LABEL_STYLE, ROW_ITEM_STYLE, ROW_ITEM_SUBLABEL_STYLE } from './styles';

const RowItem = forwardRef(({
  label,
  ariaLabel,
  sublabel,
  sublabelIcon = null,
  sublabelIconStyle = {},
  ariaValue = sublabel,
  link = false,
  onClick = VOID_FN,
  children,
  style,
  linkIcon = 'left-arrow',
  linkIconStyle = { transform: 'rotate(180deg)' },
  focusable = true,
  index = 0,
  totalCount = 0
}, ref) => {
  const Icon = useContext(IconContext);
  const { controlIconSize } = useNewStore('ui');
  const setStyles = useStyles();

  const ariaTextValue = (typeof (ariaValue) === 'function' ? ariaValue() : ariaValue);

  return (
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      aria-label={`${ariaLabel || label}, ${ariaTextValue ? `${ariaTextValue}, ` : ''}${index} sur ${totalCount}`}
      className={`${focusable && 'ftv-magneto--focusable-item'} ftv-magneto--hoverable-item`}
      style={{
        ...ROW_ITEM_STYLE,
        marginTop: 0,
        cursor: 'pointer',
        ...setStyles({
          default: { fontSize: 16 },
          'medium+large+extraLarge': { fontSize: 18 }
        })
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.keyCode === 32) onClick(e);
        if (e.keyCode === 32) e.stopPropagation();
      }}
      onClick={onClick}
    >
      <div
        style={{ ...ROW_ITEM_LABEL_STYLE, ...style, cursor: 'pointer', color: LABELS_FILL_COLOR }}
        role="presentation"
      >
        {label}
      </div>
      <div
        role="presentation"
        style={{
          ...ROW_ITEM_SUBLABEL_STYLE,
          cursor: link ? 'pointer' : 'unset',
          fontSize: style?.fontSize || 'inherit',
          color: SECONDARY_TEXT_COLOR
        }}
      >
        {sublabel ? (
          <Fragment>
            <span>{sublabel}</span>
            {sublabelIcon && (
              <Icon
                name={sublabelIcon}
                style={sublabelIconStyle}
                width={controlIconSize}
                height={controlIconSize}
              />
            )}
          </Fragment>
        ) : children}
        {
          link
          && (
            <Icon
              name={linkIcon}
              style={linkIconStyle}
              width={controlIconSize}
              height={controlIconSize}
            />
          )
        }
      </div>
    </div>
  );
});

export default RowItem;
